





































































import { Component, Watch } from 'vue-property-decorator';
import FormFooter from '@/components/FormFooter.vue';
import TagSelect from '@/components/TagSelect.vue';
import FormBase from '@/mixins/FormBase';
import { Action, Getter } from 'vuex-class';
import Farm from '@/core/interfaces/Farm';
import User from '@/core/interfaces/User';
import VehicleType from '@/core/interfaces/VehicleType';
import UserGroup from '@/core/interfaces/UserGroup';
import arrayUnique from 'array-unique';
import vSelect from 'vue-select';

@Component({
    components: { FormFooter, TagSelect, vSelect },
})
export default class UserForm extends FormBase<User> {
    @Action('saveUser')
    saveAction!: (user: Partial<User>) => Promise<User>;

    @Getter('vehicleTypes')
    vehicleTypes!: VehicleType[];

    @Getter('userGroups')
    userGroups!: UserGroup[];

    @Getter('userGroupsByUser')
    userGroupsByUser!: (id: number) => UserGroup[];

    @Getter('farmsByUserGroup')
    farmsByUserGroup!: (id: number) => Farm[];

    @Getter('farms')
    farms!: Farm[];

    @Getter('farmOptions')
    farmOptions!: { label: string; value: number }[];

    @Getter('farmById')
    farmById!: (id: number) => Farm;

    username = '';

    emails: string[] = [];

    password = '';

    farmId: number | null = null;

    userGroupIds: number[] = [];

    mainUser = false;

    @Watch('initial', { immediate: true })
    async setFromInitial(): Promise<void> {
        if (!this.initial) {
            return;
        }

        this.username = this.initial.username || '';
        this.emails = [...(this.initial.emails || [])];
        this.farmId = this.initial.farm_id || null;
        this.userGroupIds = this.initial.id
            ? this.userGroupsByUser(this.initial.id).map((group) => group.id)
            : [];
        this.mainUser = this.initial.main_user || false;
    }

    async afterSave(user: User): Promise<void> {
        await this.$store.dispatch('saveUserGroupsByUser', {
            userId: user.id,
            userGroupIds: this.userGroupIds,
        });
    }

    get parseForm(): Partial<User> {
        const user: Partial<User> = {
            ...this.initial,
            id: this.initial?.id || undefined,
            username: this.username,
            emails: this.emailsFilled,
            farm_id: this.farmId || null,
            main_user: this.mainUser,
        };

        // Sending password: null resets the password server-side, so only
        // include it when a new password was entered.
        delete user.password;
        delete user.access_token;

        if (this.password) {
            user.password = this.password;
        }

        return user;
    }

    get emailsFilled(): string[] {
        return this.emails.filter(email => !!email);
    }

    get visibleFarms(): Farm[] {
        return arrayUnique([
            ...(this.farmId ? [this.farmById(this.farmId)] : []),
            ...this.userGroupIds.flatMap((id) => this.farmsByUserGroup(id)),
        ]).sort((a, b) => a.name.localeCompare(b.name));
    }

    @Watch('emails', { immediate: true })
    updateEmails() {
        if (this.emails.length === 0) {
            this.emails.push('');
        }

        if (this.emails[this.emails.length - 1] !== '') {
            this.emails.push('');
        }
    }
}

